<img
  class="img-figure center"
  alt="You have submitted your forgot password request"
  src="/assets/success-figure.svg"
/>
<br />
<button (click)="toLogin()" mat-flat-button color="accent">
  Done
</button>
